<div class="autoplay-opts__container--title">
    <p>{{'AUTOPLAY_OPTIONS' | translate}}</p>
</div>
<div class="autoplay-opts__container--content">
    <p class="autoplay-opts__text--label">{{'NUMBER_OF_ROUNDS' | translate}}</p>
    <picker-buttons class="autoplay-opts__buttons--round-count"
                    [options]="roundCountOptions"
                    [selected]="selectedOptions['roundCount']"
                    [deselectEnabled]="true"
                    (select)="selectRoundCount($event)"></picker-buttons>
    <p class="autoplay-opts__text--label">{{'STOP_IF_CASH_DECREASE' | translate}}</p>
    <stepper-control *ngIf="balanceAvailable" class="autoplay-opts__stepper"
                     [formatWith]="formatBalanceStepperNumber"
                     [step]="stepperConfigs['cashDecreaseStopStepper'].step"
                     [maxValue]="stepperConfigs['cashDecreaseStopStepper'].maxValue"
                     [minValue]="stepperConfigs['cashDecreaseStopStepper'].minValue"
                     [initialValue]="stepperConfigs['cashDecreaseStopStepper'].initialValue"
                     (onSelect)="selectAmount('maxStackDecreaseAmount', $event)"
    ></stepper-control>
    <conditional-stepper *ngIf="balanceAvailable" class="autoplay-opts__cond-stepper" [key]="'STOP_IF_CASH_INCREASE'"
                         [formatStepperNumber]="formatBalanceStepperNumber"
                         [stepperConfig]="stepperConfigs['cashIncreaseStopStepper']"
                         [selectedValue]="selectedOptions['maxStackIncreaseAmount']?.value"
                         (onSelect)="selectAmount('maxStackIncreaseAmount', $event)"
                         (onStepperVisibilityChange)="handleStepperVisibilityChange('maxStackIncreaseAmount', $event)"
                         [initialVisibilityState]="false"></conditional-stepper>
    <conditional-stepper class="autoplay-opts__cond-stepper" [key]="'STOP_IF_SINGLE_WIN_EXCEEDS_AMOUNT'"
                         [formatStepperNumber]="formatBalanceStepperNumber"
                         [stepperConfig]="stepperConfigs['singleWinStopStepper']"
                         [selectedValue]="selectedOptions['maxAccumulatedAmount']?.value"
                         (onSelect)="selectAmount('maxAccumulatedAmount', $event)"
                         (onStepperVisibilityChange)="handleStepperVisibilityChange('maxAccumulatedAmount', $event)"
                         [initialVisibilityState]="false"></conditional-stepper>
    <conditional-stepper class="autoplay-opts__cond-stepper" [key]="'AUTO_CASH_OUT'"
                         [formatStepperNumber]="formatStepperNumber"
                         [stepperConfig]="stepperConfigs['autoCashOut']"
                         [selectedValue]="selectedOptions['autoCashOut']?.value"
                         (onSelect)="selectAmount('autoCashOut', $event)"
                         (onStepperVisibilityChange)="handleStepperVisibilityChange('autoCashOut', $event)"
                         [initialVisibilityState]="stepperConfigs['autoCashOut'].enabled ?? false"></conditional-stepper>
    <div class="autoplay-opts__container--buttons">
        <button-text class="autoplay-opts__button--bottom" [buttonModifier]="'negative'"
                     (onClick)="reset()"
        >{{'RESET' | translate}}</button-text>
        <button-text class="autoplay-opts__button--bottom" [buttonModifier]="'attention'"
                     (onClick)="start()"
        >{{'START AUTOPLAY' | translate}}</button-text>
    </div>
</div>
